// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__sktMZ","main":"styles_main___r9gs","clickEffect":"styles_clickEffect__zBkGN","pulse":"styles_pulse__nRgMY"};